<div>
  <form [formGroup]="tenantForm" (ngSubmit)="onSubmit()" autocomplete="off" class="no-scroll">
    <div style="margin-top: 120px; display: flex; justify-content: space-between; width: 76.4%; margin-left: 11.8%;">
      <button *ngIf="!auth.isYakuin" type="button" style="color: #b71c1c; font-family: Noto Sans JP;" (click)="deleteTenant()" class="outline-none h-10">{{ 'deleteTenant' | translate }}</button>
      <div class="relative mb-3 flex justify-end">
        <button type="button" style="margin-right: 20px; color: var(--text-color); font-family: Noto Sans JP;" (click)="goBack()" class="outline-none h-10">{{ 'cancel' | translate }}</button>
        <button
          type="submit"
          [disabled]="!tenantForm.valid"
          style="float: right; width: 120px"
          class="items-center justify-center text-center button w-40 h-10 rounded text-lg cursor-pointer"
        >
          {{ 'addNewTenant' | translate }}
        </button>
      </div>
    </div>
    <div style="margin-left: 11.8%; margin-bottom: 8px">
      <span style="font-family: Noto Sans JP; font-weight: bold; color: var(--text-color);">Step 1: </span>
      <span style="font-family: Noto Sans JP; color: var(--text-color);">Complete tenancy setting details</span>
    </div>
    <div class="field-class">
      <span class="field-label">*{{'tenantName' | translate}}</span>
      <input type="text" class="input-field" matInput required id="name" placeholder="Enter Tenant Name" formControlName="name">
      <div *ngIf="tenantForm.get('name')?.invalid && tenantForm.get('name')?.touched" class="error-message">
        <div *ngIf="tenantForm.get('name')?.hasError('required')">This Field is Required</div>
      </div>
    </div>
    <div class="field-class">
      <span class="field-label">{{'expDate' | translate}}</span>
      <p-inputMask
        mask="9999-99-99"
        slotChar="yyyy-mm-dd"
        formControlName="expiration_date"
        placeholder="Enter Expiration Date"
        [autoFocus]="false"
      ></p-inputMask>
    </div>
    <div class="field-class">
      <span class="field-label">{{'tenantDescription' | translate}}</span>
      <input type="text" class="input-field" matInput id="description" placeholder="Enter Tenant Description" formControlName="description">
    </div>
    <div class="field-class">
      <span class="field-label">{{'statusID' | translate}} {{'statusIDDescription' | translate}}</span>
      <input type="text" class="input-field" matInput id="status_id" placeholder="Enter Tenant Description" formControlName="status_id">
    </div>
    <div style="margin-left: 11.8%; margin-bottom: 8px">
      <span style="font-family: Noto Sans JP; font-weight: bold; color: var(--text-color);">{{'userAccess' | translate}}</span>
      <div *ngIf="!rbacEditable" style="margin: 15px 0 20px 0; font-family: Noto Sans JP; color: var(--text-color);">User access not editable.</div>
      <div *ngIf="rbacEditable">
        <div
          *ngFor="let option of roleOptions"
          style="font-family: Noto Sans JP; margin: 7px 0 5px 0; color: var(--text-color); font-size: 14px; display: flex;"
        >
          <input
            type="checkbox"
            [value]="option.id"
            [checked]="option.alwaysChecked || selectedRids.includes(option.id)"
            [disabled]="option.alwaysChecked"
            (change)="onRoleSelectionChange($event, option.id)"
            style="margin-right: 6px; margin-top: 2px"
          />
          {{ option.label | translate }}
        </div>
      </div>
    </div>
    <div style="margin: 15px 0 20px 11.8%">
      <span style="font-family: Noto Sans JP; font-weight: bold; color: var(--text-color);">Step 2: </span>
      <span style="font-family: Noto Sans JP; color: var(--text-color);">Add or edit companies & vessels</span>
    </div>
    <button
      *ngIf="rbacEditable"
      type="button"
      class="button h-10 rounded"
      style="margin-left: 11.8%; width: 140px;"
      (click)="addCompany()"
    >
      + {{"addCompany" | translate}}
    </button>
  </form>
  <div *ngIf="!rbacEditable" style="margin: 15px 0 20px 11.8%; font-family: Noto Sans JP; color: var(--text-color);">RBAC not editable.</div>
  <div *ngFor="let company of getSelectedCompanies()" class="company-section">
    <div class="company-header">
      <span>{{ company.name }}</span>
      <button class="remove-button" (click)="removeCompany(company.id)">×</button>
    </div>
    <div class="vessel-list">
      <div *ngFor="let vessel of vslDict[company.id].vessels" class="vessel-item">
        <span>{{ vessel.name }}</span>
        <button class="remove-button" (click)="removeVessel(company.id, vessel.id)">×</button>
      </div>
    </div>
  </div>
</div>